class TourismInsurancePriceRequest {
  companyid = null;
  currency = null;
  price = null;
  period = null;
  plantype = null;
  isvip = false;
  // kumdahiltype = false;
  createdby = null;
  updatedby = null;
}
export default TourismInsurancePriceRequest;
